// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1_rVc","containerItemsCenter":"Skeleton_containerItemsCenter__oTWLE"};